export default "__VITE_ASSET__BaRG6xAS__"